import {useContext} from "react"
import {EcpWorkflowContext} from "../contexts/EcpWorkflowContext"

export function useEcpWorkflowContext() {
    const context = useContext(EcpWorkflowContext)
    if (!context) {
        throw new Error("useEcpWorkflowContext must be used within a EcpWorkflowContext")
    }
    return context
}